module.exports = __webpack_public_path__ + "img/b4.adcc038b.png";